var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloudArrowIn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.194 11.612C18.757 8.17 15.809 5.5 12.25 5.5C9.494 5.5 7.1 7.111 6.007 9.65C3.859 10.292 2.25 12.32 2.25 14.5C2.25 17.257 4.493 19.5 7.25 19.5C7.80228 19.5 8.25 19.0523 8.25 18.5C8.25 17.9477 7.80228 17.5 7.25 17.5C5.596 17.5 4.25 16.154 4.25 14.5C4.25 13.096 5.449 11.743 6.923 11.484L7.504 11.382L7.696 10.824C8.399 8.773 10.144 7.5 12.25 7.5C15.007 7.5 17.25 9.743 17.25 12.5V13.5H18.25C19.353 13.5 20.25 14.397 20.25 15.5C20.25 16.603 19.353 17.5 18.25 17.5H17.25C16.6977 17.5 16.25 17.9477 16.25 18.5C16.25 19.0523 16.6977 19.5 17.25 19.5H18.25C20.456 19.5 22.25 17.706 22.25 15.5C22.25 13.619 20.945 12.038 19.194 11.612Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.25 15.5V18.5C13.25 19.0523 12.8023 19.5 12.25 19.5C11.6977 19.5 11.25 19.0523 11.25 18.5V15.5H8.25L12.25 10.5L16.25 15.5H13.25Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudArrowIn);
export default __webpack_public_path__ + "static/media/cloud_arrow_in.418c75049c096bba2778448de96579b3.svg";
export { ForwardRef as ReactComponent };